import { useReducer, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import hbrIcon from "./otherImg/hbrlitenewicon.png";
import { actionConsts, actionConts2, reducer } from "./newComponents/StateManager";
import { CustomAlertDialog } from "./newComponents/CustomAlertDialog";
import Authaxios from "./newComponents2/Authaxios";
import { CustomConfirmDialog } from "./newComponents/Customconfirmdialog";
import ChangePassword from "./newComponents2/ChangePassword";
import { ConstVariables } from "./newComponents2/ConstantVariables";


const Login = ({signInsuccess}) => {
  const [user_email,setUser_email]=useState("");
    const [pwd,setpwd]=useState("");
    const [errMsg, setErrMsg] = useState('');
    const [loading,setLoading]=useState(false);
    const [checked, setChecked] = useState(true);
    const [changePasswd, setChangePasswd] = useState(false);
    const [state,dispatch]=useReducer(reducer,{alertMessage: "", showAlert: false, showConfirmDialog: false, vcode: ""});
    const navigate = useNavigate();
    const errRef = useRef();
    const messageBody = ConstVariables.MAIL_BODY_RESET_PASS;
    const messageTitle = ConstVariables.MAIL_TITLE_RESET_PASS;


    const verifyUserCredential=async()=>{
      if (user_email.trim() === "") {
        dispatch({type: actionConsts.ALERT_MESSAGE,payload: 'Forgotten password? To help you reset your password, enter your account email to receive verification code.'});
        dispatch({type: actionConsts.SHOWALERT,payload: true});
        return;
      }
      try {
          setLoading(true);
          const res = await Authaxios.post("/sendOtp",
              JSON.stringify({email: user_email, messageBody, messageTitle}),
              {
                  headers: { 'Content-Type': 'application/json' },
                  withCredentials: false
              }
          );
          dispatch({type: actionConts2.OTP, payload: res.data.vcode});
          setLoading(false);
          dispatch({type: actionConsts.CONFIRMDIALOG, payload: true});
      } catch (error) {
          if (!error?.response) {
              dispatch({type: actionConsts.ALERT_MESSAGE,payload: ConstVariables.NO_SERVER_RESPONSE});
              dispatch({type: actionConsts.SHOWALERT,payload: true});
              setErrMsg(ConstVariables.NO_SERVER_RESPONSE)
          }else if (error?.response.status === 500) {
              dispatch({type: actionConsts.ALERT_MESSAGE,payload: ConstVariables.SERVICE_UNAVAILABLE});
              dispatch({type: actionConsts.SHOWALERT,payload: true});
              setErrMsg(ConstVariables.SERVICE_UNAVAILABLE);
          }else if (error?.response.status === 401) {
              dispatch({type: actionConsts.ALERT_MESSAGE,payload: `The provided email address ${user_email} is not valid. Enter a valid email address to receive verification code.`});
              dispatch({type: actionConsts.SHOWALERT,payload: true});
              setErrMsg("invalid email");
          }else{
              dispatch({type: actionConsts.ALERT_MESSAGE,payload: ConstVariables.UNKNOWN_ERROR});
              dispatch({type: actionConsts.SHOWALERT,payload: true});
              setErrMsg(ConstVariables.UNKNOWN_ERROR);
          }
          setLoading(false);
          errRef.current.focus();
      }
    };

    const logintoAccount = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {

        const res = await Authaxios.post("/auth",
          JSON.stringify({user_email, password:pwd}),
          {
              headers: { 'Content-Type': 'application/json' },
              withCredentials: false
          }
        );
        setLoading(false);
        localStorage.setItem("userName", res?.data.userName);
        localStorage.setItem("userEmail",user_email);
        localStorage.setItem("userProfile",res?.data.profile_pic);
        localStorage.setItem("persistLogin", checked);
        signInsuccess(true);
        navigate("/");
        
      } catch (err){
        if (!err?.response) {
          setErrMsg(ConstVariables.NO_SERVER_RESPONSE);
        }else if (err?.response.status === 500) {
            setErrMsg(ConstVariables.SERVICE_UNAVAILABLE);
        }else if (err?.response.status === 404) {
          setErrMsg("User not found, create an acoount if you haven't");
          dispatch({type: actionConsts.ALERT_MESSAGE,payload: "User not found, create an acoount if you haven't"});
          dispatch({type: actionConsts.SHOWALERT,payload: true});
        }else if (err?.response.status === 401) {
          setErrMsg("The email or password you entered is incorrect");
          dispatch({type: actionConsts.ALERT_MESSAGE,payload: "The email or password you entered is incorrect."});
          dispatch({type: actionConsts.SHOWALERT,payload: true});
        }else{
            setErrMsg(ConstVariables.UNKNOWN_ERROR);
        }
        setLoading(false);
        errRef.current.focus();
      }
  };

  const handleCallback=(inputValue)=>{
    if (inputValue === state.vcode) {
        dispatch({type: actionConsts.CONFIRMDIALOG, payload: false});
        setChangePasswd(true);
    }else{
        dispatch({type: actionConsts.ALERT_MESSAGE,payload: `Invalid verification code`});
        dispatch({type: actionConsts.SHOWALERT,payload: true});
    }
    dispatch({type: actionConts2.OTP, payload: ""});
  };

  const handlePersistLogin=(e)=>{
    if (e.target.checked) {
        setChecked(true);
    }else{
       setChecked(false);
    }
  };

  const handleCloseAlert=()=>{
    dispatch({type: actionConsts.SHOWALERT,payload: false});
  };
  


    return !changePasswd ? ( 
        <div className="useraccount">
          {state.showAlert &&
            <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={handleCloseAlert}/>
          }
          {state.showConfirmDialog &&
            <CustomConfirmDialog
            title={"User Verification"}
            formDesc={`Enter the verification code sent to ${user_email}. Request new code after: `}
            showTimer={true}
            callback={handleCallback}
            positiveBtn={"Validate"}
            closeDialog={()=> dispatch({type: actionConsts.CONFIRMDIALOG, payload: false})}
            />
          }

          <div className="flex-row2" style={{flexWrap:"wrap",gap:"20px"}}>
            <Link to={`/contact`} style={{
              borderRadius:"10px", 
              textDecoration:"none",
              backgroundColor:"white",
              padding:"5px",
              margin:"10px",fontWeight:"bold",borderLeft:"5px solid Teal",borderRight:"5px solid #ed268f"}}>
              Support Team
            </Link>
          </div>
       

            {loading && 
               <div style={{
                position:"absolute",
                top:"50%",
                left:"45%",
                width:"fit-content",
                height:"fit-content",
                border: "5px solid #00000050",
                borderTop: "5px solid #eb268f",
                borderBottom: "5px solid Teal",
                borderRadius: "50%",
                animation: "spin2 2s linear infinite",
                backgroundColor: "#FFFFFF",
                zIndex:"3"
                }}>
                  <p>Logging in...</p>
            </div>
            }


              <div className="formWrapper">
                    <div className="arrangeformheading">
                        <h3>Login</h3>
                        <img src={hbrIcon} alt="" />
                    </div>

                    <p ref={errRef} className={errMsg ? "errmsg" : "hideerrmsg"} aria-live="assertive">{errMsg}</p>

                    <form onSubmit={logintoAccount} className="formcontents">
                        <input type="email" placeholder="email" value={user_email} required onChange={e => setUser_email(e.target.value.trim())}/>
            
                        <input type="password" placeholder="enter your password" value={pwd} required onChange={e => setpwd(e.target.value.trim())}/>
                    </form>

                    <div style={{display: "flex",flex:"1",gap:"5px"}}>
                        <input type="checkbox" id="remembermydetails" checked={checked} onChange={handlePersistLogin} />
                        <label htmlFor="remembermydetails">
                            <h5 style={{color:"red"}}>Keep me Logged In always. Make sure you trust this device or else click to remove this settings.</h5>
                        </label>
                    </div>
                    
                    <button style={{border: "none", fontWeight:"bold", fontSize:"1.2em", backgroundColor:"white", padding:"10px", cursor:"pointer"}} onClick={logintoAccount}>
                      Login
                    </button>

                    <button style={{border: "none", fontWeight:"bold", backgroundColor:"transparent", padding:"10px", cursor:"pointer", color:"#0E78F9"}} 
                    onClick={verifyUserCredential}>
                        Forgotten Password ?
                    </button>

                    <h3>Don't have an account? <Link to={`/account/create`}>Create one here</Link></h3>
              </div>
        </div>
     ):(
        <ChangePassword 
          user_email={user_email}
          onSuccess={()=>setChangePasswd(false)}
        />
     );
}
export default Login;